import { gql } from '@/utilities/gql';

export const NARRATIVE_EDIT_BUTTON_FRAGMENT = gql(`
  fragment NarrativeEditButtonFields on Narrative @_unmask {
    id
    owner {
      publicId
    }
    companyId
    latestPublishedUpdate {
      id
      willLockAt
    }
    earliestPublishedUpdate {
      id
    }
  }
`);
